<template>
    <div class="main-sidebar sidebar-dark-primary elevation-4 overflow-scroll" @click.self="closeSidebar">
        <i class="d-block d-sm-none el-icon-close icon-close-sidebar" @click="handleCloseSidebar"></i>
        <a href="javascript:void(0)" class="brand-link">
            <span class="brand-text">{{ $t('titleWeb') }}</span>
        </a>
        <div class="sidebar">
            <div class="mt-3 pb-3 mb-3 account-info">
                <div class="image image-account">
                    <img src="../../../assets/img/user.svg" class="img-circle elevation-2" alt="User Image" />
                    <i @click="onShowPageInfo" :title="$t('menu.userInfo')" class="el-icon-edit-outline"></i>
                </div>
                <div class="info" v-if="userInfo">
                    <a href="javascript:void(0)" class="d-block">
                        <div class="info__plan">{{ userInfo ? (userInfo['surname'] ?? '') + ' ' + (userInfo['name'] ?? '') : '' }}</div>
                        <template v-if="!isRoleUser">
                            <div class="info__email">{{ userInfo.email }}</div>
                            <div class="info__plan" v-if="userInfo['plan']">{{ userInfo.plan ? userInfo.plan.name : '' }}</div>
                            <div v-if="userInfo['plan']">
                                {{ $t('msgCommon.textNumberDataLink') }}
                                {{ userInfo['information_group'] ? userInfo['information_group']['data_link'] : '' }}/ {{ userInfo['plan'] ? userInfo['plan']['number_data_link'] : '' }}
                            </div>
                            <div v-if="userInfo['plan']">
                                {{ $t('msgCommon.textNumberUserCount') }}
                                {{ userInfo['information_group'] ? userInfo['information_group']['user'] : '' }}/ {{ userInfo['plan'] ? userInfo['plan']['number_user'] : '' }}
                            </div>
                        </template>
                    </a>
                </div>
            </div>

            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                    <template v-for="(item, k) in MENUS">
                        <li v-if="item.subMenu && item.subMenu.length > 0 && !(item.isDisableForUser && isRoleUser) && !(item.isDisableForAdmin && !isRoleUser)" :key="k" class="nav-item menu-open">
                            <a class="nav-link" href="javascript:void(0)" :class="checkActiveMenu(k, item) ? 'active' : ''" @click="goPath(item.subMenu[0].path)">
                                <i class="nav-icon" :title="$t('menu.' + item.label)" :class="item.icon"></i>
                                <p>
                                    {{ $t('menu.' + item.label) }}
                                    <i class="right fas el-icon-arrow-left"></i>
                                </p>
                            </a>
                            <ul class="nav nav-treeview">
                                <template v-for="(subMenu, subK) in item.subMenu">
                                    <li class="nav-item" :key="'sub' + subK" v-if="!(subMenu.isDisableForUser && isRoleUser) && !(item.isDisableForAdmin && !isRoleUser)">
                                        <a class="nav-link nav-link__sub" href="javascript:void(0)" @click="goPath(subMenu.path)" :class="checkActiveSubMenu(subK, subMenu) ? 'active' : ''">
                                            <i class="far el-icon-full-screen nav-icon" :title="$t('menu.' + subMenu.label)"></i>
                                            <p>{{ $t('menu.' + subMenu.label) }}</p>
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </li>
                        <li v-else :key="k" class="nav-item">
                            <a
                                v-if="!(item.isDisableForUser && isRoleUser) && !(item.isDisableForAdmin && !isRoleUser)"
                                href="javascript:void(0)"
                                class="nav-link"
                                :class="checkActiveMenu(k, item) ? 'active' : ''"
                                @click="goPath(item.path)"
                            >
                                <i class="nav-icon" :title="$t('menu.' + item.label)" :class="item.icon"></i>
                                <p>
                                    {{ $t('menu.' + item.label) }}
                                    <span class="right badge badge-danger"></span>
                                </p>
                            </a>
                        </li>
                    </template>
                    <li class="nav-item" v-if="isRoleUser">
                        <a href="javascript:void(0)" class="nav-link" :class="$route.name === 'userInfo' ? 'active' : ''" @click="onShowPageInfo">
                            <i class="nav-icon el-icon-user-solid" :title="$t('menu.userInfo')"></i>
                            <p>
                                {{ $t('menu.userInfo') }}
                                <span class="right badge badge-danger"></span>
                            </p>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { APP_TOKEN_NAME, USER_INFO_KEY, LANGUAGE_SETTING_APP } from '@/config/constants';
import { MENUS } from '@/config/menus';
import { generateStorageKey } from '@/utils';
import moment from 'moment';
import $ from 'jquery';
export default {
    name: 'sideBarPartial',
    data: function () {
        return {
            menuActive: '',
            isShowMenu: false,
            language: window.$cookies.get(LANGUAGE_SETTING_APP) || 'ja',
            MENUS: MENUS
        };
    },
    created() {},
    mounted() {},
    methods: {
        onShowPageInfo() {
            this.$router.push({ name: 'userInfo', query: { id: this.userInfo.id } });
        },
        closeSidebar() {
            if (this.showMenu) {
                this.$store.commit('SET_SHOW_MENU', false);
                $('body').removeClass('sidebar-open');
            }
        },
        handleCloseSidebar() {
            $('body').removeClass('sidebar-open');
        },
        goPath(path) {
            $('body').removeClass('sidebar-open');
            this.menuActive = path;
            let namePage = this.$route.name;
            if (namePage !== path) {
                let pathName = path;
                if (path === 'shareList' && this.isRoleUser) {
                    pathName = 'shareListUser';
                }
                this.$router.push({ name: pathName });
            }
        },
        checkActiveMenu(subIndex, subMenuItem) {
            let namePage = this.$route.name;
            return subMenuItem.pathActive.includes(namePage);
        },
        checkActiveSubMenu(subIndex, subMenuItem) {
            if (subMenuItem && subMenuItem.pathActive && subMenuItem.pathActive.length > 0) {
                let currentPath = this.$route.name;
                let index = subMenuItem.pathActive.findIndex((el) => el === currentPath);
                return index >= 0;
            } else {
                return false;
            }
        },
        setLanguage() {
            window.$cookies.set(LANGUAGE_SETTING_APP, this.language);
            window.$i18n.locale = this.language;
            moment.locale(this.language);
        },
        showMenuLeft() {
            this.$store.commit('isShowMenuLeft', true);
        },
        goDashboard() {
            this.$router.push({ name: 'home' });
        },
        logOut() {
            let confirmCallback = () => {
                this.$store.commit('auth/logout');
                this.$cookies.set(generateStorageKey(APP_TOKEN_NAME), '');
                this.$cookies.set(generateStorageKey(USER_INFO_KEY), '');
                this.$store.commit('auth/open_close_logout', false);
                this.$router.push({ name: 'login' });
            };
            let payloadConfirm = {
                callback: confirmCallback,
                message: this.$t('popup.confirmLogout')
            };
            this.$store.commit('openConfirm', payloadConfirm);
        }
    },
    computed: {
        ...mapState(['currentMenu', 'currentPath', 'showMenu']),
        ...mapState('auth', ['userInfo']),
        isRoleUser() {
            if (localStorage.getItem('KB_DEV_CUSTOMER') || this.userInfo) {
                let user = JSON.parse(localStorage.getItem('KB_DEV_CUSTOMER')) || this.userInfo;
                if (user) {
                    let roleUser = parseInt(user.type);
                    return roleUser === 1;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        activeMenuIndex() {
            let activeIndex;
            if (this.MENUS) {
                for (let index in this.MENUS) {
                    let menuItem = this.MENUS[index];
                    if (Array.isArray(menuItem.pathActive) && menuItem.pathActive.length > 0) {
                        let i = menuItem.pathActive.findIndex((x) => x === this.currentPath);
                        if (i >= 0) {
                            activeIndex = index;
                        }
                    }
                }
            }
            return parseInt(activeIndex);
        },
        activeSubMenuIndex() {
            let activeIndex;
            if (this.MENUS) {
                for (let index in this.MENUS) {
                    let menuItem = this.MENUS[index];
                    if (Array.isArray(menuItem.pathActive) && menuItem.pathActive.length > 0) {
                        let i = menuItem.pathActive.findIndex((x) => x === this.currentPath);
                        if (i >= 0) {
                            activeIndex = i;
                        }
                    }
                }
            }
            return parseInt(activeIndex);
        },
        onCheckActive() {
            let currentPath = this.$route.name;
            let menu = null;
            this.MENUS.map((elm, indexMEnu) => {
                let index = elm.pathActive.findIndex((elm) => elm === currentPath);
                if (index >= 0) {
                    menu = this.MENUS[indexMEnu];
                }
            });
            if (menu && menu.subMenu && menu.subMenu.length > 1) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="scss">
.sidebar {
    .image {
        &.image-account {
            position: relative;
            i {
                position: absolute;
                bottom: -2px;
                left: 57%;
                color: #000000;
                background-color: #f6f6f5;
                border: 1px solid #f6f6f5;
                padding: 3px;
                border-radius: 50%;
                cursor: pointer;
                z-index: 99;
            }
        }
    }
}
.sidebar-menu {
    ul {
        li {
            cursor: pointer !important;
            a {
                &.nav-link {
                    border-radius: 0.5rem;
                }
            }
        }
    }
}
.main-sidebar {
    &-header {
        flex-shrink: 0;
        height: 64px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        background: #fff;
        border-bottom: 1px solid #dee4ec;
        border-right: 1px solid #dee4ec;
        position: fixed;
        width: 240px;
        z-index: 999;
        transition:
            left 0.3s ease,
            width 0.3s ease;
        .logo-light {
            img {
                width: 50px;
                margin-right: 10px;
                height: auto;
            }
            display: flex;
            align-items: center;
            color: #1e1d1d;
            font-size: 21px;
            font-weight: bold;
            span {
                position: relative;
                top: 2px;
            }
        }
    }

    &-loggedin {
        padding: 20px 20px 0 20px;
        display: flex;
        flex-shrink: 0;
        border-bottom: 0;
        margin-top: 64px;
    }

    .icon-close-sidebar {
        display: none;
        @include Responsive(XS) {
            display: block;
            position: absolute;
            top: 5px;
            right: 5px;
            color: #ffffff;
            font-weight: bold;
            cursor: pointer;
            z-index: 100;
        }
    }

    ul {
        li {
            cursor: pointer !important;
            a {
                &.nav-link {
                    border-radius: 0.5rem;
                    margin-bottom: 0.3rem !important;
                }
            }
        }
    }
}
.app-sidebar {
    position: fixed;
    top: -19px;
    bottom: 0;
    left: 0;
    margin-top: 18px;
    width: 240px;
    overflow: auto;
    z-index: 999;
    transition:
        left 0.3s ease,
        width 0.3s ease;
    background: #fff;
    hr {
        border-top: 1px dotted #ecedf2;
    }
    @include compatible(box-shadow, 0px 8px 14.72px 1.28px rgba(159, 150, 226, 0.7));

    &__user {
        color: #a8a8a8;
        width: 100%;
        display: inline-block;
        text-align: center;

        .user-pic {
            margin: 0 auto 0.8rem;
            width: 60px;
            height: 60px;
            border-radius: 100%;
            overflow: hidden;
            @include compatible(box-shadow, 0px 5px 5px 0px rgba(44, 44, 44, 0.2));
            img {
                height: 100%;
            }
        }

        .user-info {
            .text-dark {
                color: #031b4e !important;
                font-weight: 600;
                font-size: 14px;
                margin-top: 13px;
            }

            .text-muted {
                color: #97a3b9 !important;
                font-size: 13px;
            }
        }
    }
}
.modal-backdrop {
    background-color: rgba(0, 0, 0, 0.3) !important;
}
.brand-link {
    img {
        border: none;
    }
}
.user-panel {
    .image {
        img {
            width: 34px;
            height: 34px;
        }
    }
}
.sidebar-mini {
    .nav-link__sub {
        padding-left: 45px;
    }
    &.sidebar-collapse {
        ul {
            li {
                a {
                    &.nav-link__sub {
                        padding-left: 18px;
                    }
                }
            }
        }
    }
}
</style>
